import { getType } from "@/utils/commonUtils";
const filtersMixin = {
  filters: {
    numberWithNDigitPrecision(value, precision = 2, roundOfType = "round") {
      if (value != null && +value === 0) return 0;
      if (!value) return undefined;
      if (!isFinite(value)) return value;
      const roundOfFunctionsMap = {
        ceil: Math.ceil,
        round: Math.round,
        floor: Math.floor,
      };
      const roundOfFunction = roundOfType
        ? roundOfFunctionsMap[roundOfType]
        : (value) => value;
      if (precision === 0) return roundOfFunction(value);
      value = Number(value);
      return (+value.toFixed(precision)).toString();
    },
    na(value, symbolToDisplay = "NA", showSymbolForZero = false) {
      const valueDateType = getType(value);
      switch (valueDateType) {
        case "string":
          if (value.length === 0) return symbolToDisplay;
          return value;
        case "number":
          if (!isFinite(+value)) return symbolToDisplay;
          if (+value === 0 && !showSymbolForZero) return value;
          if (+value > 0) return value;
          return symbolToDisplay;
        case "object":
          if (Object.keys(value).length === 0) return symbolToDisplay;
          return value;
        case "array":
          if (value.length === 0) return symbolToDisplay;
          return value;
        case "null":
        case "undefined":
          return symbolToDisplay;
        default:
          return value;
      }
    },
    uppercase(value, lang) {
      if (["en", "es"].includes(lang)) {
        return value.toUpperCase();
      }
      return value;
    },
    lowercase(value, lang) {
      if (["en", "es"].includes(lang)) {
        return value.toLowerCase();
      }
      return value;
    },
    trimSpecialCharacters(value) {
      var specialChars = "!@#$^&%*()+=-[]/{}|:<>?,.";
      value = value.replace(
        new RegExp("[" + Array.from(specialChars).join("\\") + "]$", "gi"),
        ""
      );
      value = value.replace(
        new RegExp("^[" + Array.from(specialChars).join("\\") + "]", "gi"),
        ""
      );
      return value;
    },
    removeTrailingZero(value) {
      const dec = value.split(".")[1];

      if (parseInt(dec) > 0) {
        return value;
      } else {
        return value.split(".")[0];
      }
    },
    formatThousandStr: function(
      valueToBeFormatted,
      precision = 1,
      roundOfType = undefined
    ) {
      let repString;
      const roundOfFunctions = {
        ceil: Math.ceil,
        round: Math.round,
        floor: Math.floor,
      };
      const roundOfFunction = roundOfType
        ? roundOfFunctions[roundOfType]
        : (value) => value;
      if (isNaN(+valueToBeFormatted)) return undefined;
      if (+valueToBeFormatted < 1000) {
        repString = (+valueToBeFormatted).toFixed(0);
      } else if (valueToBeFormatted >= 1000 && valueToBeFormatted < 10000) {
        repString = +(valueToBeFormatted / 1000).toFixed(1).toString() + "k";
      } else {
        repString =
          (+roundOfFunction(valueToBeFormatted / 1000).toFixed(
            precision
          )).toString() + "k";
      }
      return repString.toString();
    },
    formatLakhStr: function(
      valueToBeFormatted,
      precision = 1,
      roundOfType = undefined
    ) {
      let repString;
      const roundOfFunctions = {
        ceil: Math.ceil,
        round: Math.round,
        floor: Math.floor,
      };
      const roundOfFunction = roundOfType
        ? roundOfFunctions[roundOfType]
        : (value) => value;
      if (isNaN(+valueToBeFormatted)) return 0;
      if (+valueToBeFormatted < 100000) {
        repString = (+valueToBeFormatted).toFixed(0);
      } else if (valueToBeFormatted >= 100000 && valueToBeFormatted < 1000000) {
        repString = +(valueToBeFormatted / 100000).toFixed(1).toString() + "L";
      } else {
        repString =
          (+roundOfFunction(valueToBeFormatted / 100000).toFixed(
            precision
          )).toString() + "L";
      }
      return repString.toString();
    },
  },
};
export default filtersMixin;
